/**
 * Drop hero coupon row claim flow (D5c "Tap to claim"). A real claim, not a
 * dead slab (phase-08 FR11) — but a lighter contract than the PDP buy-box's
 * afroyla-coupon-strip.js: the hero has no product/variant to price a
 * per-item saving against, and its verbatim strings are fixed ("Coupon" /
 * "SUMMER26 — 50% off" / "Tap to claim" — copy law, byte-for-byte), so it
 * can't reuse that module's paint() function, which overwrites those exact
 * nodes with its own "−$X with CODE" grammar. Same underlying action
 * (`/discount/{code}` + a `/cart.js` reconcile) and the same `theme:cart:
 * refresh` signal on success, just a 3-state label (idle -> pending ->
 * claimed) instead of the buy box's full state machine.
 */
(function () {
  'use strict';

  if (window.__aflDropCouponInit) return;
  window.__aflDropCouponInit = true;

  var ROOT_SEL = '[data-afl-drop-coupon]';
  var IDLE = 'Tap to claim';
  var PENDING = 'Adding…';
  var CLAIMED = 'Added ✓';
  var ERROR = 'Could not add — try again';

  function flagKey(code) {
    return 'afroyla:coupon:' + code;
  }
  function readFlag(code) {
    try {
      return window.localStorage.getItem(flagKey(code)) === '1';
    } catch (e) {
      return false;
    }
  }
  function writeFlag(code) {
    try {
      window.localStorage.setItem(flagKey(code), '1');
    } catch (e) {
      /* Claimed still shows for this page life. */
    }
  }

  function setLabel(root, text) {
    var label = root.querySelector('[data-afl-drop-coupon-label]');
    if (label) label.textContent = text;
  }

  function claim(root) {
    var code = root.getAttribute('data-coupon-code');
    var btn = root.querySelector('[data-afl-drop-coupon-btn]');
    if (!code || !btn || btn.disabled || root.getAttribute('data-state') === 'claimed') return;

    root.setAttribute('data-state', 'pending');
    btn.setAttribute('aria-busy', 'true');
    setLabel(root, PENDING);

    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        writeFlag(code);
        root.setAttribute('data-state', 'claimed');
        btn.setAttribute('aria-busy', 'false');
        btn.disabled = true;
        setLabel(root, CLAIMED);
        document.dispatchEvent(new CustomEvent('afroyla:coupon:claimed', { detail: { code: code } }));
        // action:'update' — refresh cart chrome (count, prices) WITHOUT the
        // auto-open the bridge applies to real adds: a claim applies a code
        // to the session, popping an (often empty) drawer over the grid was
        // rejected by the owner 2026-08-26.
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: { action: 'update' } }));
      })
      .catch(function () {
        root.setAttribute('data-state', 'error');
        btn.setAttribute('aria-busy', 'false');
        setLabel(root, ERROR);
      });
  }

  function init(root) {
    if (root.__afroylaDropCoupon) return;
    root.__afroylaDropCoupon = true;

    var code = root.getAttribute('data-coupon-code');
    if (code && readFlag(code)) {
      root.setAttribute('data-state', 'claimed');
      var btn = root.querySelector('[data-afl-drop-coupon-btn]');
      if (btn) btn.disabled = true;
      setLabel(root, CLAIMED);
    } else {
      root.setAttribute('data-state', 'idle');
      setLabel(root, IDLE);
    }

    var claimBtn = root.querySelector('[data-afl-drop-coupon-btn]');
    if (claimBtn) {
      claimBtn.addEventListener('click', function () {
        claim(root);
      });
    }
  }

  document.querySelectorAll(ROOT_SEL).forEach(init);

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(ROOT_SEL)) init(node);
          else if (node.querySelector && node.querySelector(ROOT_SEL)) node.querySelectorAll(ROOT_SEL).forEach(init);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
